import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { functionalities, privileges } from '@/shared/services/AuthService';
import MenuItemWithSecurity from '@/shared/components/MenuItemWithSecurity';
import messages from './documentMessages';

const EmailGlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onUpdateTags,
    onUpdateRelations,
    onRemoveDocuments,
    onDownloadZip,
    onSendByEmail,
  } = props;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.EmailGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItemWithSecurity
          onSelect={onUpdateTags}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.AddOrRemoveTags)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onUpdateRelations}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Update}
        >
          {intl.formatMessage(messages.AddOrRemoveRelations)}
        </MenuItemWithSecurity>
        <MenuItemWithSecurity
          onSelect={onDownloadZip}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Read}
        >
          {intl.formatMessage(messages.DownloadAsZip)}
        </MenuItemWithSecurity>
        {/* <MenuItem onSelect={onSendByEmail} disabled={disabled}>
          {intl.formatMessage(messages.SendByEmail)}
        </MenuItem> */}
        <MenuItemWithSecurity
          onSelect={onRemoveDocuments}
          disabled={disabled}
          functionality={functionalities.Documents}
          privilege={privileges.Delete}
        >
          {intl.formatMessage(messages.RemoveEmails)}
        </MenuItemWithSecurity>
      </DropdownButton>
    </span>
  );
};

EmailGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
};
EmailGlobalActionsButton.defaultProps = {
  disabled: false,
};

export default injectIntl(EmailGlobalActionsButton);
